var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBalonFundacionesinvitadas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1444,
    viewBox: "0 0 1440 1444",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1426.87 859.543C1421.61 886.848 1415.12 913.913 1406.39 939.26C1405.68 942.983 1403.72 946.468 1403.01 950.191C1342.42 1131.58 1214.32 1276.78 1052.9 1361.5C945.707 1418.06 823.234 1447.22 696.825 1443.43C659.722 1442.72 620.858 1437.8 583.71 1430.63C423.973 1399.83 285.649 1317.81 184.207 1204.29C182.208 1201.33 178.971 1198.13 176.972 1195.17C60.2988 1060.69 -5.9601 884.444 0.422507 697.751C0.855742 688.824 1.28899 679.898 1.96101 669.73C3.4995 641.709 7.51449 614.166 13.0066 585.621C23.5131 531.012 39.9723 478.838 62.3839 429.1C65.2937 420.651 69.2029 413.682 73.351 405.471C167.234 211.195 343.109 71.3438 548.041 20.7602C551.994 20.2354 556.187 18.4695 560.14 17.9448C654.221 -3.81525 754.865 -6.28957 856.403 13.29C962.894 33.8247 1058.66 76.7465 1140.93 136.375C1232.4 201.636 1305.7 287.853 1357.33 386.622C1430.51 526.874 1459.1 691.994 1426.87 859.543Z",
    fill: "#F9FBFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128.922 897.582L337.108 816.734C337.108 816.734 437.861 973.888 551.658 1049.89L473.334 1276.77C473.334 1276.77 338.779 1275.28 208.989 1175.6C210.228 1175.84 133.196 1015.54 128.922 897.582Z",
    fill: "#1569CC",
    fillOpacity: 0.21
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M309.706 285.006L546.529 88.6879L813.023 178.69C813.023 178.69 757.242 375.166 754.97 440.372C754.97 440.372 517.322 480.786 435.235 520.304C435.474 519.063 333.227 396.375 309.706 285.006Z",
    fill: "#1569CC",
    fillOpacity: 0.21
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M878.152 981.56L970.326 682.695L1251.27 644.195C1251.27 644.195 1318.17 770.365 1313.09 930.279C1313.09 930.279 1145.72 1119.39 1078.64 1147.65L878.152 981.56Z",
    fill: "#1569CC",
    fillOpacity: 0.21
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1357.33 386.622L1304.17 389.242L1295.03 390.052C1294.03 388.572 1293.27 385.851 1292.27 384.372C1259.87 312.479 1157.32 218.05 1127.95 190.505C1122.47 185.587 1119.24 182.389 1119.24 182.389L1121.67 176.422L1139.45 137.376C1232.16 202.876 1305.46 289.094 1357.33 386.622Z",
    fill: "#1569CC",
    fillOpacity: 0.21
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1054.14 1361.74C946.945 1418.3 824.472 1447.45 698.063 1443.67L681.355 1423.72L665.647 1405.24C665.647 1405.24 666.885 1405.48 669.6 1404.72C696.559 1404.77 875.603 1401.97 992.379 1335.67L1003.05 1340.3L1054.14 1361.74Z",
    fill: "#1569CC",
    fillOpacity: 0.21
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M777.768 195.06L777.724 188.615C781.633 181.646 913.073 125.901 1131.57 178.332L1129.43 189.502C912.163 137.31 788.152 194.488 786.675 195.49L783.676 191.05L777.768 195.06Z",
    fill: "#1569CC",
    fillOpacity: 0.21
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1250.92 666.009L1240.02 662.619C1284.62 530.92 1295.37 368.238 1294.61 365.517L1306 366.425C1306.76 369.146 1297 533.308 1250.92 666.009Z",
    fill: "#1569CC",
    fillOpacity: 0.21
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M972.414 698.542C971.414 697.062 890.951 541.247 715.302 426.285L721.166 415.832C899.053 532.512 981.754 690.045 982.753 691.525L972.414 698.542Z",
    fill: "#1569CC",
    fillOpacity: 0.21
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M327.618 839.36C328.095 836.878 348.205 632.237 433.625 501.974L444.053 507.846C360.349 635.866 340.717 838.025 340.239 840.507L327.618 839.36Z",
    fill: "#1569CC",
    fillOpacity: 0.21
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M325.326 290.592C325.326 290.592 320.134 290.878 311.75 294.41C276.451 304.336 177.505 338.029 63.3834 430.58C66.2932 422.131 70.2024 415.161 74.3505 406.951C187.278 320.607 283.031 290.159 314.138 281.999C319.568 280.471 323.522 279.947 323.522 279.947L325.326 290.592Z",
    fill: "#1569CC",
    fillOpacity: 0.21
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M552.615 110.457L541.232 109.549L543.336 91.9345L549.04 22.241C552.994 21.7162 557.186 19.9503 561.139 19.4256L555.197 90.3601L552.615 110.457Z",
    fill: "#1569CC",
    fillOpacity: 0.21
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M145.064 907.13L136.962 915.865C134.725 914.146 132.726 911.187 130.727 908.227C67.1761 838.051 25.5425 754.081 1.66074 697.989C2.09397 689.063 2.52723 680.136 3.19925 669.969C22.8443 721.382 64.8054 816.999 134.592 894.814C137.59 899.253 141.827 903.932 145.064 907.13Z",
    fill: "#1569CC",
    fillOpacity: 0.21
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M222.761 1164.1L212.943 1175.07L186.684 1204.76C184.685 1201.8 181.448 1198.61 179.449 1195.65L207.424 1163.71L215.526 1154.98L222.761 1164.1Z",
    fill: "#1569CC",
    fillOpacity: 0.21
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M702.928 1431.74C620.636 1405.57 461.429 1271.9 454.716 1266.75L461.579 1257.77C462.578 1259.25 626.261 1396.36 706.315 1420.81L702.928 1431.74Z",
    fill: "#1569CC",
    fillOpacity: 0.21
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M540.081 1056.67L540.992 1045.26C543.468 1045.74 734.223 1055.49 883.299 974.83L889.057 984.95C737.027 1067.62 542.557 1057.15 540.081 1056.67Z",
    fill: "#1569CC",
    fillOpacity: 0.21
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M996.182 1349.28L987.231 1342.4C1050.76 1265.84 1079.94 1120.87 1080.18 1119.63L1091.32 1121.78C1090.13 1127.98 1061.19 1271.71 996.182 1349.28Z",
    fill: "#1569CC",
    fillOpacity: 0.21
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1406.39 939.26C1405.68 942.983 1403.72 946.468 1403.01 950.191L1299.75 932.855L1301.9 921.685L1406.39 939.26Z",
    fill: "#1569CC",
    fillOpacity: 0.21
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalonFundacionesinvitadas);
export default __webpack_public_path__ + "static/media/balon-fundacionesinvitadas.9e8d85f63b613d58e4c3f9b892575e44.svg";
export { ForwardRef as ReactComponent };